module.exports = __webpack_public_path__ + "img/data_check_28dp_00366D.270787a4.svg";